/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Field_Auth_StyleInputs */



/**
* | output |
* | --- |
* | "Authentication" |
*
* @param {External_Apis_Field_Auth_StyleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_field_auth_style = /** @type {((inputs?: External_Apis_Field_Auth_StyleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Field_Auth_StyleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Authentifizierung")
	return /** @type {LocalizedString} */ ("Authentication")
});